import { Tab, TableCell, TableRow, styled, tableCellClasses, tableRowClasses } from "@mui/material";
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
const blue = {
  100: '#DAECFF',
  200: '#b6daff',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  900: '#003A75',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

export const StyledTab = styled(Tab)({
  minWidth: '20%',
  fontSize: 'x-small',
  borderLeft: '0.5px solid rgba(0, 0, 0, 0.1)',
  borderRight: '0.5px solid rgba(0, 0, 0, 0.1)',
  "&:last-child":{
    borderRight: '0px'
  },
  "&.MuiButtonBase-root": {
    minHeight:0,
    minWidth:0

  },
  "&.Mui-selected": {
    color: "white",
    backgroundColor: "#1976d2",
  }
});
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#EDEDED",
      color: '#707070',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  
export const StyledTableRow2 = styled(TableRow)(({ theme }) => ({
    '&:nth-child(4n + 1)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:nth-child(4n + 2)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

export const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#707070",
      color: 'white',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  export const StyledTableCellBinary = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#EDEDED",
      color: 'black',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  export const StyledTableRowBinary = styled(TableRow)(({ theme, selected }) => ({
  
    '&:nth-of-type(odd)': {
      backgroundColor:selected? 'rgba(25, 118, 210, 0.08)': theme.palette.action.hover,
    },
    [`&.${tableRowClasses.selected}`]:{
      border:'3px solid #1976d2',
      boxShadow: '0px 4px 8px rgba(0,0,0,0.2)',
      transition: 'box-shadow 0.3s',
  
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border:0,
    },
  }));

  export const TextareaAutosize = styled(BaseTextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

    &:hover {
      border-color: black;
    }

    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
    &:error {
      border-color: red;
    }

    // firefox
    &:focus-visible {
      outline: 0;
    }
`,
);

  export const modalStyle ={
    borderRadius: '5px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height:'80%',
    maxHeight:'80%',
    overflowY:'hidden',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  }

  export const modalUpload = {
    borderRadius: '5px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height:'55%',
    maxHeight:'80%',
    overflowY:'hidden',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  export const submitModalStyle = {
    borderRadius: '5px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height:'27%',
    maxHeight:'90%',
    maxWidth: '100%',
    overflowY:'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  
  export const deleteModalStyle = {
    borderRadius: '5px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height:'40%',
    maxHeight:'90%',
    overflowY:'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  export const continueStyleModal = {
    borderRadius: '5px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height:'30%',
    maxHeight:'90%',
    overflowY:'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };